const { UTM_SOURCE_PARAMETER } = require('../constants/ProfileConstants');

function getUtmSource() {
    if (typeof window === 'undefined') return null;

    const utmSource = new URLSearchParams(window.location.search).get(UTM_SOURCE_PARAMETER);
    if (utmSource) {
        try {
            window.sessionStorage.setItem(UTM_SOURCE_PARAMETER, utmSource);
        } catch (e) {
            // Ignore unavailable sessionStorage; this request still carries the URL value.
        }
        return utmSource;
    }

    try {
        return window.sessionStorage.getItem(UTM_SOURCE_PARAMETER);
    } catch (e) {
        return null;
    }
}

function addUtmSourceToUrl(url) {
    const utmSource = getUtmSource();
    if (!utmSource || !url) return url;

    try {
        const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:/i.test(url);
        const parsedUrl = new URL(url, window.location.origin);
        if (!parsedUrl.searchParams.has(UTM_SOURCE_PARAMETER)) {
            parsedUrl.searchParams.set(UTM_SOURCE_PARAMETER, utmSource);
        }

        return isAbsoluteUrl ? parsedUrl.toString() : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch (e) {
        return url;
    }
}

function addUtmSourceToParams(params) {
    const utmSource = getUtmSource();
    if (!utmSource) return params;

    return {
        ...params,
        [UTM_SOURCE_PARAMETER]: params?.[UTM_SOURCE_PARAMETER] || utmSource,
    };
}

module.exports = {
    getUtmSource,
    addUtmSourceToUrl,
    addUtmSourceToParams,
};
